import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Nav, NavItem, NavLink } from "reactstrap";
import "./Orders.scss";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SetStateAction, useEffect, useState } from "react";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import OrderHistoryCard from "./components/OrderHistoryCard";
import classnames from "classnames";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import orderStatus01 from "assets/images/order-status-01.png";
import orderStatus02 from "assets/images/order-status-02.png";
import orderStatus03 from "assets/images/order-status-03.png";
import orderStatus04 from "assets/images/order-status-04.png";
import io from "socket.io-client";
import { Environment } from "environment";
import { Constant } from "utils/enums";
import Exportcsv from "pages/MyEcommerce/components/Exportcsv.modal";
import InfiniteScroll from "react-infinite-scroll-component";
const userStr = localStorage.getItem(Constant.seller);
const user = userStr ? JSON.parse(userStr) : null;
const userId = user?.sellerId;
var url = `${Environment.socketUrl}?userId=${userId}`
const socket = io(url);

const Orders = (props: any) => {
  document.title = "Orders | BuyPass";
  const [counts, setCounts] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [orders, setOrders] = useState<any[]>([]);
  const [ordersMobile, setOrdersMobile] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("all");
  const [ExportcsvModal, setExportcsvModal] = useState(false)
  var [statusTab, setStatusTab] = useState("all");
  const [hasMore, setHasMore] = useState(true);

  const headerNavigations = [
    {
      label: "All Orders",
      value: "all",
      active: true,
      count: counts?.allCount, 
    },
    {
      label: "Pending",
      value: "pending",
      active: false,
      count: counts?.pendingCount,
    },
    {
      label: "Accepted",
      value: "accepted",
      active: false,
      count: counts?.acceptedCount,
    },
    {
      label: "Rejected",
      value: "rejected",
      active: false,
      count: counts?.rejectedCount,
    },
    {
      label: "Delivered",
      value: "delivered",
      active: false,
      count: counts?.deliveredCount,
    },
    {
      label: "Cancelled",
      value: "cancelled",
      active: false,
      count: counts?.cancelledCount,
    },
    {
      label: "Return",
      value: "return",
      active: false,
      count: counts?.returnCount,
    },

  ];
  const [ConfirmModal, setConfirmModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [proofModal, setProofModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [navigations, setNavigations] = useState(headerNavigations[0]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const fetchMore = () => {
  const nextPage = currentPage + 1;

  // Don't increase page if already last
  if (!hasMore) return;

  setCurrentPage(nextPage);
  onGetOrders(nextPage);
  onGetOrdersWithStatus(nextPage,activeTab)
};




  useEffect(() => {
    const handler = setTimeout(() => {
      onGetOrders(currentPage);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line
  }, [searchTerm, currentPage]);

  const onGetOrders = async (page: number) => {
    try {
      const response = await axios.get(
        `api/v1/order/sellerorders?page=${page}&count=${itemsPerPage}&status=${statusTab}&keyword=${searchTerm}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        const newOrders = response.data.data || [];
        setOrdersMobile((prevOrders: any) => {
  const existingIds = new Set(prevOrders.map((o: any) => o._id));
  const uniqueNewOrders = newOrders.filter((o: any) => !existingIds.has(o._id));
  return [...prevOrders, ...uniqueNewOrders];
});

        setCounts(response.data.counts);
       const totalCount = response.data.totalCount;
const newTotalPages = Math.ceil(totalCount / itemsPerPage);
setTotalPages(newTotalPages);

const isLastPage = page >= newTotalPages;
setHasMore(!isLastPage);

      }
    } catch (err: any) {
    } finally {
    }
  };
       const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };

   const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  const onGetOrdersWithStatus = async (page: number, status: any) => {
    try {
      setStatusTab(status);
      console.log(statusTab);
      const response = await axios.get(
        `api/v1/order/sellerorders?page=${page}&count=${itemsPerPage}&status=${status}&keyword=${searchTerm}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        const newOrders = response.data.data || [];
        setOrdersMobile((prevOrders: any) => {
  const existingIds = new Set(prevOrders.map((o: any) => o._id));
  const uniqueNewOrders = newOrders.filter((o: any) => !existingIds.has(o._id));
  return [...prevOrders, ...uniqueNewOrders];
});

        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
        const isLastPage = page >= totalPages;
        setHasMore(!isLastPage);
      }
    } catch (err: any) {
    } finally {
    }
  };

  useEffect(() => {
    onGetOrders(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage,itemsPerPage]);

  useEffect(() => {
    socket.on("getOrderData", () => {
      onGetOrders(currentPage);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  setOrdersMobile([]);
  setCurrentPage(1);
  setHasMore(true);
  onGetOrders(1);
}, [activeTab, statusTab,searchTerm]);



  return (
    <div className="page-content QuickComerceordersMainPage page-content-mobile">
      <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Manage Orders"
          pageTitle="Orders"
          pageTitleRoute="/manage-products"
        />

        <ConfirmOrderModal
          show={ConfirmModal}
          onCloseClick={() => setConfirmModal(false)}
        />
        <Exportcsv
               show={ExportcsvModal}
               countPage={itemsPerPage}
               isQuickCommerce={true}
               onCloseClick={() => setExportcsvModal(false)}
               />

        <Card>
          <div className="navigatiovCardDv">
            <div className="OrderCardHeader">
            <h2>Order History</h2>
            <button style={{ cursor: "pointer" }} onClick={() => setExportcsvModal(true)} className="mobile-hide">Export CSV</button>
            </div>
            {counts && (
              <Nav
                className="nav-tabs nav-tabs-custom nav-success"
                role="tablist"
               >
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "all" })}
                    href="#"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "all");
                      setActiveTab("all");
                    }}
                    data-testing-id="all_orders"
                  >
                    All Orders
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.allCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "newOrder" })}
                    href="#"
                    data-testing-id="newOrderTabar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "newOrder");
                      setActiveTab("newOrder");
                    }}
                  >
                    New Orders
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.newOrderCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "orderAccepted",
                    })}
                    href="#"
                    data-testing-id="acceptedTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "orderAccepted");
                      setActiveTab("orderAccepted");
                    }}
                  >
                    Accepted
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.acceptedCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "readyToShip",
                    })}
                    href="#"
                    data-testing-id="acceptedTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "readyToShip");
                      setActiveTab("readyToShip");
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.readyToShipCount}
                    </span>
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "packingOrder",
                    })}
                    href="#"
                    data-testing-id="packingOrderTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "packingOrder");
                      setActiveTab("packingOrder");
                    }}
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.packingCount}
                    </span>
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "handedOver",
                    })}
                    href="#"
                    data-testing-id="riderAssignedTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "handedOver");
                      setActiveTab("handedOver");
                    }}
                  >
                    Shipping
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.handedoverCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "delivered",
                    })}
                    href="#"
                    data-testing-id="deliveredTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "delivered");
                      setActiveTab("delivered");
                    }}
                   >
                    Delivered
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.deliveredCount}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "cancelledByBuyer",
                    })}
                    href="#"
                    data-testing-id="cancelledByBuyerTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "cancelledByBuyer");
                      setActiveTab("cancelledByBuyer");
                    }}
                   >
                     Cancelled
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.cancelledByBuyerCount}
                    </span>
                  </NavLink>
                </NavItem>

                {/* <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "readyToShip",
                    })}
                    href="#"
                    data-testing-id="readyToShipTabbar_orders"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "readyToShip");
                      setActiveTab("readyToShip");
                    }}    
                  >
                    Ready To Ship
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.readyToShipCount}
                    </span>
                  </NavLink>
                </NavItem> */}

                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "cancelledBySeller",
                    })}
                    href="#"
                    data-testing-id="rejectedTabbar_campaign"
                    onClick={() => {
                      setCurrentPage(1);
                      onGetOrdersWithStatus(currentPage, "cancelledBySeller");
                      setActiveTab("cancelledBySeller");
                    }}
                  >
                    Rejected
                    <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                      {counts.cancelledBySellerCount}
                    </span>
                  </NavLink>
                </NavItem>
                
              </Nav>
            )}

            <div className="serchNavigationDv">
              <div className="SearchandExport">
                 <div className="serchDv">
                <i className="bx bx-search"></i>
                <input
                  type="text"
                  placeholder="Search"
                  data-testing-id="serachInput_order"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                  </div>
                 <button style={{ cursor: "pointer" }} onClick={() => setExportcsvModal(true)} className="mobile-show">Export CSV</button>
              </div>

              <div className="paginationDv mobile-hide">
                <nav aria-label="Page navigation example">
                  <ul className="pagination detailPagepagi">
                     <select value={itemsPerPage} style={{margin:'5px'}} onChange={handleItemsPerPageChange}>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={80}>80</option>
          <option value={100}>100</option>
        </select>
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link"
                        data-testing-id={"pagination" + currentPage}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <i
                          style={{ height: "11px" }}
                          className="bx bxs-left-arrow"
                        ></i>
                      </button>
                    </li>
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                    }).map((page) => (
                      <div>
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                          key={page}
                        >
                          <button
                            style={{ height: "26px" }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                            data-testing-id={"pagination" + currentPage}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link orderPg"
                        style={{
                          height: "26px !important",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ width: "6px", height: "11px" }}
                        ></i>
                      </button>
                    </li>
                     <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="tableHead">
              <div className="tableHeadChild firtChild">
                <h4>Product</h4>
              </div>
              <div className="tableHeadChild secondChild">
                <h4>Total Amount</h4>
              </div>
              <div className="tableHeadChild">
                <h4>Delivery Type</h4>
              </div>
              <div className="tableHeadChild fourthChild">
                <h4>Order Status</h4>
              </div>
              <div className="tableHeadChild lastChild">
                <h4>Actions</h4>
              </div>
            </div>
          </div>
        </Card>
  {navigations.label === "All Orders" && (
  <>
  {window.innerWidth <= 768 ? (
  <div className="mobileViewScroll">
    {ordersMobile.length === 0 ? (
      <h2>No Data Found!</h2>
    ) : (
      <InfiniteScroll
        dataLength={ordersMobile.length}
        next={fetchMore}
        hasMore={hasMore}
        loader={<p>Loading...</p>}
        scrollThreshold={0.95}
      >
        {ordersMobile.map((o, i) => (
          <OrderHistoryCard
            key={o._id}
            order={o}
            index={i}
            activeTab={activeTab}
            setOrders={setOrdersMobile}
            setTotalPages={setTotalPages}
          />
        ))}
      </InfiniteScroll>
    )}
  </div>
) : (
  <div className="mobileViewScroll">
    {orders.length > 0 ? (
      orders.map((o, i) => (
        <OrderHistoryCard
          key={o._id}
          order={o}
          index={i}
          activeTab={activeTab}
          setOrders={setOrders}
          setTotalPages={setTotalPages}
        />
      ))
    ) : (
      <h2>No Data Found!</h2>
    )}
  </div>
)}

  </>
)}




      </Container>

      <Container fluid style={{ display: "none" }}>
        <BreadCrumb
          title="Manage Orders"
          pageTitle="Orders"
          pageTitleRoute="/manage-orders"
        />

        <div className="ordertype-list">
          <span>All Orders</span>
          <span className="active">
            <i>20</i>New Orders
          </span>
          <span>Accepted</span>
          <span>Ready To Ship</span>
          <span>Shipping</span>
          <span>Delivered</span>
          <span>Cancelled</span>
          <span>Rejected</span>
        </div>

        <div className="orders-list">
          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>

            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="order-status">
              <p>
                <figure></figure>
                <span>Logistic partner</span>
              </p>
              <p>
                <figure></figure>
                <span>Picked up</span>
              </p>
              <p>
                <figure></figure>
                <span>Shipping</span>
              </p>
              <p>
                <figure></figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>
          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="video-proof">✅ Video Proof Uploaded</div>
            <div className="order-status">
              <p>
                <figure></figure>
                <span>Logistic partner</span>
              </p>
              <p>
                <figure></figure>
                <span>Picked up</span>
              </p>
              <p>
                <figure></figure>
                <span>Shipping</span>
              </p>
              <p>
                <figure></figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-ready-ship">Ready To Ship</button>
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>

          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="order-status">
              <p className="active">
                <figure>
                  <img src={orderStatus01} alt="" />
                </figure>
                <span>Logistic partner</span>
              </p>
              <p>
                <figure></figure>
                <span>Picked up</span>
              </p>
              <p>
                <figure></figure>
                <span>Shipping</span>
              </p>
              <p>
                <figure></figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-ready-ship">Ready To Ship</button>
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>

          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="order-status">
              <p className="active conneted">
                <figure>
                  <img src={orderStatus01} alt="" />
                </figure>
                <span>Logistic partner</span>
              </p>
              <p className="active">
                <figure>
                  <img src={orderStatus02} alt="" />
                </figure>
                <span>Picked up</span>
              </p>
              <p>
                <figure></figure>
                <span>Shipping</span>
              </p>
              <p>
                <figure></figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-ready-ship">Handover</button>
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>

          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="order-status">
              <p className="active conneted">
                <figure>
                  <img src={orderStatus01} alt="" />
                </figure>
                <span>Logistic partner</span>
              </p>
              <p className="active conneted">
                <figure>
                  <img src={orderStatus02} alt="" />
                </figure>
                <span>Picked up</span>
              </p>
              <p className="active">
                <figure>
                  <img src={orderStatus03} alt="" />
                </figure>
                <span>Shipping</span>
              </p>
              <p>
                <figure></figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-ready-ship">Track Order</button>
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>

          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p>x 1</p>
                <p className="order-price">Rs. 107,000</p>
              </div>
            </div>
            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Invoice
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Picklist
              </p>
              <p>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                AWB
              </p>
              <p className="inactive">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {" "}
                  <path
                    d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z"
                    className="fill"
                  />{" "}
                  <path
                    d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z"
                    className="fill"
                  />{" "}
                </svg>{" "}
                Rider Handover
              </p>
            </div>
            <div className="order-status">
              <p className="active conneted">
                <figure>
                  <img src={orderStatus01} alt="" />
                </figure>
                <span>Logistic partner</span>
              </p>
              <p className="active conneted">
                <figure>
                  <img src={orderStatus02} alt="" />
                </figure>
                <span>Picked up</span>
              </p>
              <p className="active conneted">
                <figure>
                  <img src={orderStatus03} alt="" />
                </figure>
                <span>Shipping</span>
              </p>
              <p className="active">
                <figure>
                  <img src={orderStatus04} alt="" />
                </figure>
                <span>Delivered</span>
              </p>
            </div>
            <div className="order-action-row">
              <button className="btn btn-ready-ship">Track Order</button>
              <button className="btn btn-view-detail">Edit Price</button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Orders;
